import { Link } from "react-router-dom";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function Footer() {
  const { settings } = useSiteSettings();
  const s = settings || {};
  const brandLeft = (s.brand_name || "Abbot Asia").split(" ")[0] || "Abbot";
  const brandRight = (s.brand_name || "Abbot Asia").split(" ").slice(1).join(" ") || "Asia";

  return (
    <footer data-testid="site-footer" className="bg-jade text-ivory mt-24">
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="font-serif text-3xl md:text-4xl leading-tight">{brandLeft} <span className="italic text-copper">{brandRight}</span></p>
          <p className="mt-4 text-ivory/70 max-w-md text-[15px] font-light leading-relaxed" data-testid="footer-blurb">
            {s.footer_blurb || "Thoughtful journeys. Meaningful connections."}
          </p>
          {(s.abta_number || s.atol_number) && (
            <div className="mt-6 flex items-center gap-5 text-ivory/55 text-[11px] tracking-[0.14em] uppercase">
              {s.abta_number && <span data-testid="footer-abta">ABTA {s.abta_number}</span>}
              {s.abta_number && s.atol_number && <span aria-hidden className="block w-1 h-1 rounded-full bg-ivory/30" />}
              {s.atol_number && <span data-testid="footer-atol">ATOL {s.atol_number}</span>}
            </div>
          )}
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow text-copper">Explore</p>
          <ul className="mt-5 space-y-3 text-[13px] text-ivory/80">
            <li><Link to="/destinations">Destinations</Link></li>
            <li><Link to="/journeys">Journeys</Link></li>
            <li><Link to="/about">Our Approach</Link></li>
            <li><Link to="/journal">Journal</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="eyebrow text-copper">Travel</p>
          <ul className="mt-5 space-y-3 text-[13px] text-ivory/80">
            <li><Link to="/contact">Start Your Custom Trip</Link></li>
            <li><Link to="/login">Client Portal</Link></li>
            <li className="pt-2">
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/site-copy.pdf`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-site-copy-pdf"
                className="text-ivory/60 hover:text-copper text-[12px] italic"
              >Download site copy (PDF)</a>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow text-copper">Office</p>
          <ul className="mt-5 space-y-3 text-[13px] text-ivory/80">
            {s.address_line1 && <li data-testid="footer-address-1">{s.address_line1}</li>}
            {s.address_line2 && <li data-testid="footer-address-2">{s.address_line2}</li>}
            {(s.postcode || s.country) && (
              <li data-testid="footer-address-3">{[s.postcode, s.country].filter(Boolean).join(", ")}</li>
            )}
            {s.phone && <li className="pt-3" data-testid="footer-phone">{s.phone}</li>}
            {s.email && <li data-testid="footer-email">{s.email}</li>}
            {s.hours_weekday && <li className="pt-3 text-ivory/55 text-[12px]" data-testid="footer-hours-weekday">{s.hours_weekday}</li>}
            {s.hours_weekend && <li className="text-ivory/55 text-[12px]" data-testid="footer-hours-weekend">{s.hours_weekend}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory/15">
        <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[12px] text-ivory/50">
          <p>
            © {new Date().getFullYear()} Abbot Travel
            {s.company_no && <> · Registered in the UK No. {s.company_no}</>}
            {s.vat_no && <> · VAT No. {s.vat_no}</>}
          </p>
          {s.tagline && <p className="tracking-[0.2em] uppercase text-copper text-[11px]">{s.tagline}</p>}
        </div>
      </div>
    </footer>
  );
}
